<div>
  <div class="flex items-center justify-between mb-2">
    <label class="font-semibold">Items</label>
    <div class="flex gap-2">
      <p-button
        label="Add Item"
        icon="pi pi-plus"
        (onClick)="onAddBlankItem()"
      />
      <p-button
        label="Add Blueprint"
        icon="pi pi-file"
        (onClick)="onAddBlueprint()"
      />
    </div>
  </div>

  @if (linkError) {
    <p-message severity="warn" [text]="linkError" styleClass="mb-2 w-full" />
  }

  <!-- The next div gives the grid column widths.
  This needs to match the grid column widths in blueprint-item-data-tree.component.html
  -->
  <div
    class="pt-3 grid gap-2 mb-2 bg-surface-switch-100 text-xs font-semibold text-muted-color border-b pb-1"
    [ngClass]="
      tradeStudyToolFeaturesEnabled
        ? 'grid-cols-[25px_1.2fr_75px_0.5fr_55px_1.3fr_80px_1.8fr_0.9fr_110px]'
        : 'grid-cols-[25px_1.2fr_75px_0.5fr_55px_1.3fr_80px_70px_0.9fr_1fr_110px]'
    "
  >
    <div></div>
    <!-- 25px -->
    <div>Name</div>
    <!-- 1.2fr -->
    <div>Qty</div>
    <!-- 75px -->
    <div>Qty Type</div>
    <!-- 0.5fr -->
    <div pTooltip="Parts processed in one batch run" tooltipPosition="top">
      Batch
    </div>
    <!-- 55px -->
    <div>Pricing</div>
    <!-- 1.3fr -->
    <div>Cost</div>
    <!-- 80px -->
    @if (!tradeStudyToolFeaturesEnabled) {
      <div>Markup %</div>
      <!-- 70px -->
      <div>Tax Code</div>
      <!-- 0.9fr -->
    }
    <div>Material</div>
    <!-- 1fr / 1.8fr in trade study mode -->
    @if (tradeStudyToolFeaturesEnabled) {
      <div>CapEx</div>
      <!-- 0.9fr -->
    }
    <div>Actions</div>
    <!-- 110px -->
  </div>

  <app-blueprint-selector-modal
    [(visible)]="showBlueprintSelector"
    [blueprints]="allowedBlueprintsForAdd"
    [notice]="selectorNotice"
    (blueprintConfirmed)="onBlueprintSelected($event)"
  ></app-blueprint-selector-modal>

  @if (quoteItemDataEditorService.items(); as items) {
    @if (items && items.length > 0) {
      @if (
        (quoteItemDataEditorService.dragging$ | async) || true;
        as draggingWrapper
      ) {
        <div
          class="flex flex-col gap-1"
          [class.dragging-active]="quoteItemDataEditorService.dragging$ | async"
        >
          @for (
            item of rootItems;
            track item.persistent_id;
            let index = $index
          ) {
            <div
              pDroppable
              (drop)="quoteItemDataEditorService.drop(item, 'before')"
              class="drop-line"
              [class.hidden]="item.persistent_id.startsWith('ref-')"
            ></div>
            <app-blueprint-item-data-tree
              [item]="item"
              [allItems]="items"
              [allBlueprints]="allBlueprints"
              [currencyCode]="currencyCode"
              [tradeStudyToolFeaturesEnabled]="tradeStudyToolFeaturesEnabled"
              [consumablesEnabled]="consumablesEnabled"
              [equipmentOptions]="equipmentOptions"
              [consumableOptions]="consumableOptions"
              (addChild)="onAddChildToItem($event)"
              (removeItem)="onRemoveItem($event)"
            />
            @if ($last) {
              <div
                pDroppable
                (drop)="quoteItemDataEditorService.drop(item, 'endOfList')"
                class="drop-line"
                [class.hidden]="item.persistent_id.startsWith('ref-')"
              ></div>
            }
          }
        </div>
      }
    } @else {
      <div class="border rounded p-8 text-center text-muted-color">
        <p>No items yet. Click "Add Item" to get started.</p>
      </div>
    }
  }
</div>
